import React from 'react';
import './FileInput.less';

const FileInput = ({
  id,
  hasError,
  errorMessage,
  isDisabled,
  label,
  supportingText,
  maxLength,
  name,
  onBlur,
  onChange,
  onKeyUp,
  value,
  additionalClasses,
  onKeyDown,
  tabIndex,
  accept,
  ref,
}) => {
  const isIOS = () => {
    let platform = navigator?.userAgent || navigator?.platform || 'unknown';

    return (
      /iPhone|iPod|iPad|iPad Simulator|iPhone Simulator|iPod Simulator/.test(platform) ||
      // iPad on iOS 13 detection
      (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
    );
  };

  const isSafari = () => {
    let platform = navigator?.userAgent || navigator?.platform || 'unknown';

    var isSafari = /^((?!Chrome|Android).)*Safari/i.test(platform);
    return isSafari;
  };

  return (
    <div
      className={`thule-file-input ${isDisabled ? 'disabled' : ''} ${hasError ? 'error' : ''} ${additionalClasses || ''}`}
    >
      {label && <label htmlFor={id}>{label}</label>}
      <div className="position-relative">
        <input
          className={`${isIOS() || isSafari() ? '' : 'adjusted-margin'}`}
          tabIndex={tabIndex}
          type="file"
          id={id}
          disabled={isDisabled}
          maxLength={maxLength}
          name={name}
          onBlur={onBlur}
          onChange={onChange}
          onKeyUp={onKeyUp}
          value={value}
          onKeyDown={onKeyDown}
          accept={accept}
          ref={ref}
        />
        {hasError && <i className={`trailing-icon le-icon-warning error`}></i>}
      </div>
      {supportingText && !hasError && (
        <div className="supporting-text paragraph--xs" dangerouslySetInnerHTML={{ __html: supportingText }}></div>
      )}
      {hasError && (
        <div
          className="supporting-text paragraph--xs error-message"
          dangerouslySetInnerHTML={{ __html: errorMessage }}
        ></div>
      )}
    </div>
  );
};

export default FileInput;
